import { FetchClient } from "../../utils/fetchClient";

export function getEightByEightConfigurations(id = 1) {
    return FetchClient(`/data/eight-by-eight/configuration?id=${id}`).GET({})
}

export function changeLeadCallbackStatus(configId = 1, status = 1) {
    return FetchClient(`/data/eight-by-eight/configuration/eightbyeight-lead-callback`).PUT({ payload: JSON.stringify({ id: configId, status: status }) })
}